import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { fetchEmployeePositionReferTextSuccess, fetchEmployeePositionFastRefersSuccess, fetchEmployeePositionFastArchiveSuccess } from "../actions/EmployeePosition";
import { ActionTypes } from "../../constants/ActionTypes";
import { ShowError } from "../../helper/Alert";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

const getEmployeePositionReferText = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get("refer/getEmployeePositionReservedReferText");
}

const getEmployeePositionFastRefers = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get("refer/getEmployeePositionFastRefers");
}

const getEmployeePositionFastArchive = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get("archive/getEmployeePositionFastArchives?folderTypeKind=Inbox&loadArchive=true&loadPersonalArchive=true");
}

function* fetchEmployeePositionReferTextRequest(): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedEmployeePositionReferText = yield call(getEmployeePositionReferText);
        yield put(fetchEmployeePositionReferTextSuccess(fetchedEmployeePositionReferText.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchEmployeePositionReferText() {
    yield takeEvery(ActionTypes.GET_EMPLOYEEPOSITION_REFER_TEXT, fetchEmployeePositionReferTextRequest);
}

//FAST REFER
function* fetchEmployeePositionFastRefersRequest(): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedEmployeePositionFastRefers = yield call(getEmployeePositionFastRefers);
        yield put(fetchEmployeePositionFastRefersSuccess(fetchedEmployeePositionFastRefers.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchEmployeePositionFastRefers() {
    yield takeEvery(ActionTypes.GET_EMPLOYEE_POSITION_FAST_REFERS, fetchEmployeePositionFastRefersRequest);
}

//FAST ARCHIVE
function* fetchEmployeePositionFastArchiveRequest(): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedEmployeePositionFastArchive = yield call(getEmployeePositionFastArchive);
        yield put(fetchEmployeePositionFastArchiveSuccess(fetchedEmployeePositionFastArchive.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchEmployeePositionFastArchive() {
    yield takeEvery(ActionTypes.GET_EMPLOYEE_POSITION_FAST_ARCHIVE, fetchEmployeePositionFastArchiveRequest);
}

// ****************************************** */
export default function* rootSaga() {
    yield all([fork(fetchEmployeePositionReferText), fork(fetchEmployeePositionFastRefers), fork(fetchEmployeePositionFastArchive)]);
}
